<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-10 header-margin">
        <div class="text-center  p-2">
            <div v-if="errors.notExistToken">
                <div class="text-center p-2">
                    <h3>{{ $t('auth.changeEmail.timeOverTokenTitle') }}</h3>
                </div>
                <div class="text-center-text p-2">
                    {{ $t('auth.notExistTokenText') }}
                </div>
                <div class="text-center">
                    <div class="pb-4 ">
                        <router-link to="/" class="btn btn-primary text-center-btn" @click.native="handleOnClickLogout()" role="button">{{$t('auth.changeEmail.buttom') }}</router-link>
                    </div>
                </div>
            </div>
            <div v-if="errors.timeOverToken">
                <div class="text-center p-2">
                    <h3>{{ $t('auth.changeEmail.timeOverTokenTitle') }}</h3>
                </div>
                <div class="show-check-email-message text-center-text p-2" v-html="$t('auth.changeEmail.timeOverTokenText')"></div>
                <div class="text-center">
                    <div class="pb-4 ">
                        <router-link to="/" class="btn btn-primary text-center-btn" @click.native="handleOnClickLogout()" role="button">{{$t('auth.changeEmail.buttom') }}</router-link>
                    </div>
                </div>
            </div>
            <div v-if="errors.notLatestToken">
                <div class="text-center p-2">
                    <h3>{{ $t('auth.changeEmail.timeOverTokenTitle') }}</h3>
                </div>
                <div class="show-check-email-message text-center-text p-2" v-html="$t('auth.notLatestTokenText')"></div>
                <div class="text-center">
                    <div class="pb-4 ">
                        <router-link to="/" class="btn btn-primary text-center-btn" @click.native="handleOnClickLogout()" role="button">{{$t('auth.changeEmail.buttom') }}</router-link>
                    </div>
                </div>
            </div>
            <div v-if="successFlag">   
                <div class="text-center p-2">
                    <h3>{{ $t('auth.changeEmail.successTitle') }}</h3>
                </div>
                <div class="text-center-text p-2">
                    {{ $t('auth.changeEmail.successText') }}
                </div>
                <div class="text-center">
                    <div class="pb-4 ">
                        <router-link to="/" class="btn btn-primary text-center-btn" @click.native="handleOnClickLogout()" role="button">{{$t('auth.changeEmail.buttom') }}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import userService from '../../services/UserService';

    export default {
        data() {
            return {
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
                successFlag: false
            }
        },
        created() {
            var params　= [];
            this.token = this.$route.query.t;
            this.mail = this.$route.query.m;
            params['token'] = this.token;
            params['mail'] = this.mail;
            this.fetchUserData(params);
        },
        name: 'edit-user-profile-module',
        methods: {
            getDefaultFields() {
                return {
                    timeOverToken: '',
                    lastToken: '',
                    success: '',
                    notExistToken: '',
                    notLatestToken: '',
                };
            },
            async fetchUserData(params) {
                this.errors = this.getDefaultFields();

                try {
                    await userService.setChangeEmail({
                        ...params
                    });
                    this.successFlag = true;
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                            }
                        })
                    }
                } 
            },
        },
    }

</script>
<style scoped>
    .text-center-text{
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .show-check-email-message {
        text-align: center;
    }
    .show-check-email-message >>> br {
        display: inline;
    }
    @media screen and (max-width: 767px) {
        .show-check-email-message {
            text-align: left;
        }
        .show-check-email-message >>> br {
            display: none;
        }
    }
</style>
